import BackButton from './parts/BackButton'
import Content from './parts/Content'
import { AnyConnectionOptions } from '@/features/print/types'
import FormProvider from '@/features/settings/components/PrinterConfiguration/form/Provider'
import { Form, OnFormSubmit } from '@/features/settings/components/PrinterConfiguration/form/types'
import ScrollWrapper from '@/features/settings/components/ScrollWrapper'
import DismissOverlayProvider from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface PrinterConfigurationProps {
    initialFormValues: Partial<Form>
    connectionOptions: AnyConnectionOptions
    onBack: () => void
    onFormSubmit: OnFormSubmit
}

const PrinterConfiguration: FC<PrinterConfigurationProps> = ({
    initialFormValues,
    connectionOptions,
    onBack,
    onFormSubmit,
}) => {
    return (
        <DismissOverlayProvider>
            <ScrollWrapper contentContainerStyle={styles.container}>
                <BackButton onBack={onBack} />
                <FormProvider initialFormValues={initialFormValues}>
                    <Content connectionOptions={connectionOptions} onFormSubmit={onFormSubmit} />
                </FormProvider>
            </ScrollWrapper>
        </DismissOverlayProvider>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 12,
        paddingVertical: 48,
        maxWidth: 680,
        width: '100%',
        marginHorizontal: 'auto',
    },
})

export default PrinterConfiguration
